import { useDispatch } from "react-redux"
import { Link, useNavigate } from "react-router-dom"
import holder from '../assets/images/profile_holder.png'

export default function MainHeader({data}:any){
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const logOut = () => {
        dispatch({type: 'USER_LOGOUT'});
        navigate('/login')
    }

    return(
        <header className="row p-2 my-4 align-items-center rounded border shadow">   
            <div className="col-1 ms-3 p-0">
                <img className={`img-fluid rounded ${data.profileImage ?? "shadow"}`}src={data.profileImage ? window.location.origin.toString() + data.profileImage : holder} alt="profile" style={{maxHeight:"100px"}}/>
            </div>

            <div className="col m-0 p-3">
                <h5 className="fw-bold mt-0 mb-2">وقت بخیر {data.name}،</h5>
                <p className="well m-0">وبسایتِ {data.site}</p>
            </div>

            <div className="col text-end">
                <div className="d-grid gap-2 d-md-block justify-content-md-end">
                    <a href={data.status >= 1 ? data.url : data.sub_domain} target="_blank" className="btn btn-info text-light me-md-2" rel="noreferrer"><i className="zmdi zmdi-globe-alt me-1"></i>مشاهده سایت</a>
               
                    <button className="btn btn-outline-secondary dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false">
                        <i className="zmdi zmdi-account-circle me-1"></i>حساب کاربری
                    </button>
                    <ul className="dropdown-menu text-small shadow">
                        <li><h6 className="dropdown-header">{data.name + ' ' + data.family}</h6></li>
                        <li><span className="dropdown-header">شماره کاربری: {data.mobileNum}</span></li>
                        <li><span className="dropdown-header">پکیج فعال: {data.accType}</span></li>
                        <li><span className="dropdown-header">اعتبار پکیج: {data.expire > 0 ? data.expire : 0} روز</span></li>
                        <li><hr className="dropdown-divider"/></li>
                        <li><Link className="dropdown-item" to="/domain"><i className="zmdi zmdi-globe-lock zmdi-hc-lg"></i> مدیریت دامنه</Link></li>
                        <li><Link className="dropdown-item" to="/package"><i className="zmdi zmdi-shopping-cart-plus zmdi-hc-lg"></i> خرید پکیج</Link></li>
                        <li><Link className="dropdown-item" to="/invoice"><i className="zmdi zmdi-receipt zmdi-hc-lg"></i> صورتحساب ها</Link></li>
                        <li><hr className="dropdown-divider"/></li>
                        <li><button className="dropdown-item  text-bg-danger text-center" onClick={logOut}><i className="zmdi zmdi-sign-in me-1"></i>خروج</button></li>
                    </ul>
                </div>
            </div>
        </header>
   )
}